import React from 'react';
import PropTypes from 'prop-types';

export const SvgImage = ({ width, height, stroke }) => (
  <svg width={width || '14px'} height={height || '14px'} viewBox="0 0 14 14" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinejoin="round">
      <g transform="translate(-528.000000, -631.000000)" stroke={stroke} strokeWidth="2">
        <g transform="translate(513.000000, 618.000000)">
          <g transform="translate(10.000000, 8.000000)">
            <g>
              <path
                d="M8,6 L16,6 C17.1045695,6 18,6.8954305 18,8 L18,16 C18,17.1045695 17.1045695,18 16,18 L8,18 C6.8954305,18 6,17.1045695 6,16 L6,8 C6,6.8954305 6.8954305,6 8,6 Z M9.66666667,10.6666667 C10.2189514,10.6666667 10.6666667,10.2189514 10.6666667,9.66666667 C10.6666667,9.11438192 10.2189514,8.66666667 9.66666667,8.66666667 C9.11438192,8.66666667 8.66666667,9.11438192 8.66666667,9.66666667 C8.66666667,10.2189514 9.11438192,10.6666667 9.66666667,10.6666667 Z M18,14 L14.6666667,10.6666667 L7.33333333,18"
                id="Combined-Shape"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

SvgImage.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  stroke: PropTypes.string,
};

SvgImage.defaultProps = {
  stroke: '#000000',
};
